import React from "react"

const OldSolution = () => {
  return (
    <div>
      hello
    </div>
  )
};

export default OldSolution
